import { IconButton } from "@hortis/ui/button";
import { Edit5 } from "@hortis/ui/icons";
import { Tooltip, TooltipContent, TooltipTrigger } from "@hortis/ui/tooltip";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCreateAccessionStore } from "src/features/create-accession/components/create-accession-store";
import { useAccessRole } from "src/features/permissions/use-access-role";
import { useNavSites } from "./use-nav-sites";

export const NewDropdown = ({ onNavigate }: { onNavigate?: () => void }) => {
  const { setCreateAccessionDialogOpen } = useCreateAccessionStore();
  const { activeSite } = useNavSites();
  const { canEdit } = useAccessRole();
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        !canEdit ||
        activeSite == null ||
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement ||
        event.ctrlKey ||
        event.altKey ||
        event.metaKey ||
        document.querySelector("[data-radix-focus-guard]") != null ||
        (event.target instanceof HTMLDivElement &&
          event.target.className.includes("ProseMirror"))
      ) {
        return;
      }

      if (event.key === "c") {
        setCreateAccessionDialogOpen(true);
        onNavigate?.();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [activeSite, canEdit, navigate, onNavigate, setCreateAccessionDialogOpen]);

  return canEdit && activeSite != null ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton
          ariaLabel="New accession"
          onClick={() => {
            setCreateAccessionDialogOpen(true);
            onNavigate?.();
          }}
          size="sm"
          data-cy="new-accession-nav-button"
        >
          <Edit5 className="h-4 w-4" />
        </IconButton>
      </TooltipTrigger>
      <TooltipContent className="z-99999 flex! flex-row! items-center gap-1.5 py-1.5 pr-2">
        Create accession
        <div className="rounded-md border border-grey-800 bg-grey-700 px-1 py-px text-[11px] font-medium text-white">
          C
        </div>
      </TooltipContent>
    </Tooltip>
  ) : (
    <></>
  );
};
